// extracted by mini-css-extract-plugin
export default {"component":"ServiceFeeAppliesNotice__component-ZQuJ","lineItemLabel":"ServiceFeeAppliesNotice__lineItemLabel-EMsT"};